import React from 'react';
import { useParams } from 'react-router'
import axios from "axios"
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import SimpleTable from '../helper/SimpleTable';
import PageHeader from '../helper/PageHeader';
import {zoomOnlyCourseId} from '../../constants/global.js'


const tableCells = [
    //{ id: 'ID', label: 'ID', centered: false },
    // { id: 'first_name', label: 'First Name', centered: false },
    // { id: 'last_name', label: 'Last Name', centered: false },
    { id: 'name', label: 'Name', centered: false },
    { id: 'email', label: 'Email', centered: false },
    { id: 'lang', label: 'Language', centered: false },
    { id: 'needCEUResult', label: 'Need CEU', centered: false },
    { id: 'needTestResult', label: 'Need Test', centered: false },
    { id: 'regDate', label: 'Registration Date', centered: false },
    { id: 'studentUsername', label: 'User Name', centered: false },
    { id: 'type', label: 'Training Type', centered: false },
];

const tableCells2 = [
    //{ id: 'ID', label: 'ID', centered: false },
    // { id: 'first_name', label: 'First Name', centered: false },
    // { id: 'last_name', label: 'Last Name', centered: false },
    { id: 'name', label: 'Name', centered: false },
    { id: 'email', label: 'Email', centered: false },
    { id: 'lang', label: 'Language', centered: false },
    { id: 'regDate', label: 'Registration Date', centered: false },
    { id: 'studentUsername', label: 'User Name', centered: false },
    { id: 'type', label: 'Training Type', centered: false },
    {id:'status', label:'Status', centered: false }
];


function TrainingProvAttendees(props){
    const history = useHistory();
    const params = useParams();
    // const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const [table1, setTable1] = useState([]);
    const [table2, setTable2] = useState([]);

    const id = params.id;

    console.log('props', props)
    console.log('params', params)

  //  const fromDate = Date(props.location.state.fromDate, 'yyyy/MM/dd')
    const fromDate = moment(props.location.state.fromDate).format('MMMM DD YYYY')

    const workShopID = props.location.state.classid

    
    async function getData(){
        axios.get('/api/trainingCode/students/' + id)
            .then((res)=>{
                console.log('res', res);
                let newRes = res.data.students.map((u) => {
                    u.needCEUResult = u.needCEU == null ? 'Null' : u.needCEU === false ? 'No' : 'Yes'
                    u.needTestResult = u.needTest === false ? 'No' : 'Yes'
                    u.regDate = moment(u['registerDate']).format('LLL')
                    u.name = u['first_name'] + " " +  u['last_name']
                    u.lang = u.language.includes('ENG') ? 'English' : 'Spanish'
                    return u;
                }

                
                
                   
                );
                console.log('new res', newRes);

                const newRes_table1 = newRes.filter( (d)=>d.courseId === zoomOnlyCourseId )
                const newRes_table2 = newRes.filter( (d)=>d.courseId !== zoomOnlyCourseId )
                console.log('table 1', newRes_table1);
                console.log('table 2', newRes_table2);
                // setData(res.data);
                
                
                 newRes_table2.map((u) => {
                    u.needCEUResult = 'Null' 
                    u.needTestResult = 'Null'
                    return u;
                }  

                );

                setTable1(newRes_table1);
                setTable2(newRes_table2);
                console.log('table1',newRes_table1 );
                console.log('table2',newRes_table2 );
                setLoading(true);
            })
        
    }
    

    useEffect(()=>{
        getData();
    }, []);


    return (
        <>
            <PageHeader
                title={"Attendee List for class " + workShopID + " on " + fromDate }
                cancel={history.goBack}
            />
            <PageHeader
                title={"Zoom Class Attendee List"}
            />
           {
               loading
               ?
               <>
                    <SimpleTable
                        data={table1}
                        cellKey={"trainingId"}
                        tableCells={tableCells}
                            />
               </>
               :
               <>
               </>
           }
           <PageHeader
                title={"Attendees with test records"}
            />
           {
               loading
               ?
               <>
                    <SimpleTable
                        data={table2}
                        cellKey={"trainingId"}
                        tableCells={tableCells2}
                            />
               </>
               :
               <>
               </>
           }
            
        </>
    );
}

export default TrainingProvAttendees;